module.exports = __webpack_public_path__ + "static/media/PopularCafeNF.d2f17720.woff2";